(() => {
  const ROOT_SEL = '[data-vmg-root]';
  const MAP_SEL  = '[data-vmg-map]';
  const IMG_SEL  = '[data-vmg-img]';

  let instances = [];
  let lastVariantId = null;
  let pollTimer = null;
  let historyPatched = false;

  function findVariantInput() {
    // meest voorkomende plek
    return document.querySelector('form[action^="/cart/add"] input[name="id"]');
  }

  function getVariantId() {
    // 1) URL (sommige themes doen dit)
    const urlId = new URL(window.location.href).searchParams.get('variant');
    if (urlId) return String(urlId);

    // 2) Hidden input[name="id"] (veel themes doen dit)
    const idInput = findVariantInput();
    if (idInput && idInput.value) return String(idInput.value);

    return null;
  }

  function renderAll(force = false) {
    const id = getVariantId();
    if (!id) return;

    if (!force && id === lastVariantId) return;
    lastVariantId = id;

    instances.forEach((inst) => {
      const v = inst.map[id];
      if (!v || !v.src) {
        inst.img.hidden = true;
        inst.img.removeAttribute('src');
        return;
      }
      inst.img.hidden = false;
      inst.img.src = v.src;
      inst.img.alt = v.alt || '';
    });
  }

  function boot() {
    instances = [];
    document.querySelectorAll(ROOT_SEL).forEach((root) => {
      const mapEl = root.querySelector(MAP_SEL);
      const imgEl = root.querySelector(IMG_SEL);
      if (!mapEl || !imgEl) return;

      let map = {};
      try {
        map = JSON.parse(mapEl.textContent || '{}');
      } catch (e) {
        console.error('VMG JSON parse error', e);
        return;
      }

      instances.push({ root, map, img: imgEl });
    });

    // force render na (re)boot
    renderAll(true);
  }

  function setupListeners() {
    // 1) Vaak genoeg al: change/click
    document.addEventListener('change', () => requestAnimationFrame(() => renderAll()), true);
    document.addEventListener('click',  () => setTimeout(renderAll, 0), true);

    // 2) Back/forward
    window.addEventListener('popstate', () => setTimeout(renderAll, 0));

    // 3) Als theme history API gebruikt zonder reload
    if (!historyPatched) {
      historyPatched = true;

      ['pushState', 'replaceState'].forEach((m) => {
        const orig = history[m];
        if (!orig) return;
        history[m] = function () {
          const ret = orig.apply(this, arguments);
          setTimeout(renderAll, 0);
          return ret;
        };
      });
    }

    // 4) Belangrijk: observe hidden input[name="id"] value changes
    const tryObserveVariantInput = () => {
      const input = findVariantInput();
      if (!input) return false;

      const obs = new MutationObserver(() => renderAll());
      obs.observe(input, { attributes: true, attributeFilter: ['value'] });

      // Sommige themes updaten .value property i.p.v. attribute → vangnet:
      input.addEventListener('input', renderAll);
      input.addEventListener('change', renderAll);

      return true;
    };

    // probeer nu en later nog eens (als form later in DOM komt)
    if (!tryObserveVariantInput()) {
      setTimeout(tryObserveVariantInput, 500);
      setTimeout(tryObserveVariantInput, 1500);
    }

    // 5) Laatste vangnet: polling (licht)
    if (!pollTimer) {
      pollTimer = setInterval(() => renderAll(), 250);
    }

    // 6) Als je theme product HTML swapt (AJAX), dan verdwijnen/verschijnen roots opnieuw:
    const bodyObs = new MutationObserver(() => {
      // Als onze root weg is of opnieuw is toegevoegd, herboot
      // (goedkoop: gewoon herbooten bij DOM mutaties)
      boot();
    });
    bodyObs.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', () => {
    boot();
    setupListeners();
  });

  // Theme editor
  document.addEventListener('shopify:section:load', () => {
    boot();
    renderAll(true);
  });
})();
